/** CMS NPI check digit (10-digit NPI with 80840 prefix for Luhn). */
export function isValidNpi(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 10 || !/^\d{10}$/.test(digits)) return false;

  const payload = `80840${digits}`;
  let sum = 0;
  let alternate = false;
  for (let i = payload.length - 1; i >= 0; i -= 1) {
    let n = Number(payload[i]);
    if (alternate) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    alternate = !alternate;
  }
  return sum % 10 === 0;
}

export function normalizeNpi(value: string): string {
  return value.replace(/\D/g, "").slice(0, 10);
}
